import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListItem = _resolveComponent("AdListItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
      return (_openBlock(), _createBlock(_component_AdListItem, {
        key: item.adId,
        ad: item,
        viewType: _ctx.viewType.value,
        isActive: _ctx.selected && _ctx.selected.adId === item.adId,
        onSelected: _ctx.onSelected,
        onHover: _ctx.onHover
      }, null, 8, ["ad", "viewType", "isActive", "onSelected", "onHover"]))
    }), 128))
  ]))
}